import { get } from 'svelte/store';
import { clientSettings } from '../../../stores/api';
import { getJobPin } from './JobsOnMap';

export class LocationSearchItem {

    private id: string;
    private name: string;
    private coords: { x: number; y: number };
    private address: any;
    private color: string;
    private icon: any;
    private mapObject: any;
    private map: any;
    private active: boolean;
    public clickable: boolean = true;

    constructor(data: any, map: any, fts: any) {
        this.map = map;
        this.id = data.id;
        this.name = data.name;
        this.coords = data.xy;
        this.address = data.address;
        this.color = data.color;
        this.icon = getJobPin(
            this.color,
            30,
            {},
            get(clientSettings).display.icon_style
        );
        this.mapObject = new Targeo.MapObject.Point(
            this.coords,
            this.icon,
            'job_'+this.id,
            {
                name: this.name,
                zIndex: 590,
                visible: true,
                balloon: { title: this.id, body: this.name },
                mouseButtonActions: { left: function () {} },
                fGetContextMenu: function() { return ['*']; }
            }
        );
        this.active = false;
    }

    clickHandler() {
        console.log('LocationSearchItem, clickHandler', this.active);
        if (this.active) {
            Targeo.Base.Map.zoomAndCenter(this.coords, Math.min(19, this.map.getZoom()));
        }
    }

    activateHandler(click: boolean) {
        console.log('LocationSearchItem, activateHandler');
        this.active = true;
        if (click) {
            this.clickHandler();
        }
    }

    deactivateHandler() {
        console.log('LocationSearchItem, deactivateHandler');
        this.active = false;
    }

    showOnMap() {
        console.log('LocationSearchItem, showOnMap');
        this.map.UOAdd(this.mapObject);
    }

    hideOnMap() {
        console.log('LocationSearchItem, hideOnMap');
        this.map.UORemove(this.mapObject.id);
    }

    getSuggestProperties() {
        console.log('LocationSearchItem, getSuggestProperties');
        return {icon: this.icon, view: this.name+' ('+this.id+')'};
    }

    getIcon() {
        let iconElement = document.createElement('img');
        iconElement.src = this.icon.imageUrl;
        iconElement.style.width = this.icon.w+'px';
        iconElement.style.height = this.icon.h+'px';
        return iconElement;
    }

    getName() {
        return this.name;
    }

    getDescription() {
        return '';
    }

    getBounds() {
        console.log('LocationSearchItem, getBounds');
        return {minX: this.coords.x, minY: this.coords.y, maxX: this.coords.x, maxY: this.coords.y};
    }

    getContextMenuObject() {
        console.log('LocationSearchItem, getContextMenuObject');
        return this.mapObject;
    }

    resultListFormatFunction() {
        console.log('LocationSearchItem, resultListFormatFunction');
        return this.resultCard();
    }

    resultCard() {
        console.log('LocationSearchItem, resultCard');
        let element = document.createElement('div');
        element.className = 'targeo-fts-resultlist-item';
        //element.style.display = 'flex';
        //element.style.alignItems = 'center';
        //element.style.gap = '10px';
        let iconElement = document.createElement('div');
        iconElement.className = 'targeo-fts-resultlist-item-icon';
        iconElement.appendChild(this.getIcon());
        element.appendChild(iconElement);
        let textElement = document.createElement('span');
        let description = [];
        if (this.address) {
            description.push((this.address.street || '')+' '+(this.address.house || ''));
            description.push((this.address.pcode || '')+' '+(this.address.city || ''));
        }
        description = description.map(d => d.trim()).filter(d => d.length > 0);
        textElement.innerHTML = '<div class="targeo-fts-resultlist-item-name">'+this.name+'</div>'+(description.length > 0 ? '<div class="targeo-fts-resultlist-item-description">'+description.join(', ')+'</div>' : '');
        element.appendChild(textElement);
        return element;
    }

}